export * from '../components/CollectionPageNew';

export { WidgetsFormProvider } from '../components/FormPage';
